module.exports = __webpack_public_path__ + "static/media/wallet-icon.5c16d682.svg";